export const TRANSACTION_STATUS_MAP = {
  SUCCESS: "success",
  PROCESSING: "primary",
  PENDING: "warning",
  FAILED: "error",
};

export const TRANSACTION_TABLE_STATUS_MAP = {
  SUCCESS: "success",
  PROCESSING: "primary",
  PENDING: "warning",
  FAILED: "error",
};

export const SERVICE_CODE_OPTIONS = [
  { value: "all", label: "All" },
  { value: "inflow", label: "Inflow" },
  { value: "outflow", label: "Outflow" },
];

export const SERVICE_CODE_MAP = {
  inflow: ["PC2B", "LipaBidhaaC2B"],
  outflow: ["PB2C", "LipaBidhaa", "PB2B"],
};

export const DEFAULT_PAGINATION = {
  pageIndex: 0,
  pageSize: 10,
};

export const DEFAULT_FILTERS = {
  searchQuery: "",
  dateRange: { startDate: null, endDate: null },
  serviceFilter: "all",
  merchantId: "",
};

export const USER_ROLES = {
  SUPER_ADMIN: "ROLE_SUPER_ADMIN",
};

export const EMPTY_FIELD_PLACEHOLDER = "—";

export const TABLE_EMPTY_PLACEHOLDER = "-";
